import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useAccessToken } from "../../../common/hooks/useAccessToken";
import { showLoader, hideLoader } from "../../../store/common/slice";
import { TenantsCard } from "./TenantsCard";
import { StyledTenants } from "./Tenants.styled";

export function Tenants({ buildingID, apartmentNumber }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const client = useAccessToken();

    const [mainTenants, setMainTenants] = useState([]);
    const [otherTenants, setOtherTenants] = useState([]);

    useEffect(async() => {
        if (!client) return;

        dispatch(showLoader());
        const response = await client.tenants.getTenantsForBuilding(buildingID);
        if (response?.apartments) {
            const apt = response.apartments.filter(item => item.apartmentNum === apartmentNumber);
            const tenants = apt[0].tenants.slice();
            const mainTenants = tenants.filter(({ tenant }) => tenant.isActive && tenant.isPrimary);
            setMainTenants(mainTenants);
            const otherTenants = tenants.filter(({ tenant }) => tenant.isActive && !tenant.isPrimary);
            setOtherTenants(otherTenants);
        }
        dispatch(hideLoader());
    }, [client, apartmentNumber, buildingID]);

    const renderTitles = () => {
        return (
            <div className="tenants-titles">
                <div></div>
                <div>{t('reports.ownership_type')}</div>
                <div>{t('reports.tenantName')}</div>
                <div>{t('reports.tenantPhone')}</div>
                <div>{t('payments.mail')}</div>
            </div>
        )
    };

    return (
        <StyledTenants>
            <div className="tenants-title">{t('reports.mainTenants')}</div>
            <div className="tenants-wrapper">
                {renderTitles()}
                {mainTenants.map((tenant, i) => <TenantsCard tenant={tenant} isPrimary key={i} />)}
            </div>

            <div className="tenants-title margin-top">{t('reports.previousTenants')}</div>
            <div className="tenants-wrapper">
                {renderTitles()}
                {otherTenants.map((tenant, i) => <TenantsCard tenant={tenant} key={i} />)}
            </div>
        </StyledTenants>
    )
}